import React, {Suspense, useEffect} from 'react';
import { Routes, Route, Outlet, Link, useSearchParams, useNavigate } from "react-router-dom";
import Page1 from './pages/Page1';
// import Page2 from './Pages/Page2';
import HomePage from './pages/HomePage';
//import DemoPage from './pages/DemoPage';
import LoginPage from './pages/LoginPage';
import ReCaptchaProvider from './layout/ReCaptchaProvider';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';

 const DemoPage = React.lazy(() => {return import('./pages/DemoPage')});

// import Dashboard from './Pages/Dashboard';

export default function Router(props) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirectUrl");
  
  useEffect(()=>{
    if(redirectUrl)
  {
      if(redirectUrl==='contact'){
        navigate('/contact');
      }
      else if(redirectUrl==='about')
        navigate('/about');
  }
  });
  
  
  return (
    
    <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="contact" element={<ReCaptchaProvider><ContactPage /></ReCaptchaProvider>} />
        <Route path="about" element={<AboutPage />} />

        <Route path="demo" element={<DemoPage />} />
        <Route path="login" element={<ReCaptchaProvider><LoginPage /></ReCaptchaProvider>} />


          {/* Using path="*"" means "match anything", so this route
                acts like a catch-all for URLs that we don't have explicit
                routes for.  */}
        
        <Route path="*" element={<HomePage />} />
      </Routes>
      
  );
}